import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';

import { Dialog } from '@osago/ui';

import LoginForm from '../components/loginForm';
import { CLIENT_URL, DOMAIN_NAME } from '../config/api';
import { useAppSelector } from '../store';

const LoginPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  const [hasAuth] = useState(() => !!localStorage.authInfo);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('success') === 'true') {
      openModal();
    }
  }, []);

  if (isAuthenticated || hasAuth) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login flex flex-col items-center justify-center flex-grow p-4">
      <Helmet>
        <title>Вход в личный кабинет | {DOMAIN_NAME}</title>
      </Helmet>
      <LoginForm />

      {isModalOpen && (
        <Dialog onClose={closeModal}>
          <h2 className="mb-6 text-xl font-bold text-center">
            Поздравляем с покупкой полиса!
          </h2>
          <p className="mb-4">
            Ваш полис успешно оплачен и будет доставлен на вашу электронную
            почту в течение 20 минут.
          </p>
          <p>
            Также полис будет доступен в личном кабинете, данные для авторизации
            мы отправили вам отдельным письмом. Если у вас возникли какие-либо
            вопросы или сложности, пожалуйста, напишите нашим специалистам в
            онлайн-чат, который доступен на главной странице нашего сервиса{' '}
            <a
              className="text-royalblue hover:underline"
              href={CLIENT_URL}
              target="_blank"
            >
              {CLIENT_URL}
            </a>
          </p>
        </Dialog>
      )}
    </div>
  );
};

export default LoginPage;
